<template>
  <div :class="{'is-invalid': showValidationError}">
    <!-- Ensure that if no boxes are checked, we send an empty list to the server.
         This mimics the behavior of Rails form helpers. -->
    <input :name="nameForInputField" type="hidden" value="">

    <div :class="{'checkbox-grid': displayInColumns}">
      <div v-for="option in options" :key="valueForOption(option)" class="form-check checkbox">
        <label class="form-check-label" :for="idForOption(option)">
          <input :id="idForOption(option)" v-model="selectedIds" class="form-check-input" type="checkbox" :name="nameForInputField"
                 :value="valueForOption(option)" :disabled="disabledForOption(option)" @change="updateSelection" @focus="$emit('focus')">
          {{ displayNameForOption(option) }}
        </label>
      </div>
    </div>

    <validation-errors v-if="showValidationError" :errors="validationErrors" />
  </div>
</template>

<script>
import checkboxesInputMixin from './checkboxes-input-mixin'

export default {
  mixins: [ checkboxesInputMixin ],

  emits: ['focus']
}
</script>

<style lang="scss" scoped>
  @use "~common_styles/breakpoints" as breakpoints;

  .checkbox-grid {
    @include breakpoints.screen-md-up {
      column-count: 3
    }

    @include breakpoints.screen-mobile-only {
      column-count: 2
    }
  }
</style>
